import React, { useRef } from 'react';
import './home.css';
import { motion, useInView } from "framer-motion";
import firstImgTitle from '../../assets/images/png/3.png';
import secongImgTitle from '../../assets/images/png/6.png';
import about from '../../assets/images/about.png';


function Home() {

    const heroRef = useRef(null);
    const heroInView = useInView(heroRef);

    const aboutRef = useRef(null);
    const aboutInView = useInView(aboutRef);

    const card1Ref = useRef(null);
    const card1InView = useInView(card1Ref);

    const card2Ref = useRef(null);
    const card2InView = useInView(card2Ref);

    const card3Ref = useRef(null);
    const card3InView = useInView(card3Ref);

    return (
        <>
            {/* Hero Section */}
            <section className="hero-section d-flex align-items-center justify-content-center">
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-md-12 col-sm-12 ">
                            <motion.p
                                ref={heroRef}
                                initial={{ opacity: 0 }}
                                animate={heroInView ? { opacity: 1 } : { opacity: 0 }}
                                transition={{ duration: 1 }}
                            >
                                <div className='imgTitle'>
                                    <img src={firstImgTitle} alt="firstImgTitle" />
                                    <img src={secongImgTitle} alt="secongImgTitle" />
                                </div>
                            </motion.p>
                        </div>
                    </div>
                </div>
            </section>

            {/* About Section */}
            <section className="homeSection2" id="about">
                <div className="container">

                    <motion.h1
                        ref={aboutRef}
                        initial={{ opacity: 0, y: -100 }}
                        animate={aboutInView ? { opacity: 1, y: 0 } : { opacity: 0, y: -100 }}
                        transition={{ duration: 0.9 }}
                        >
                        <h1 className="about-title text-center">
                            هندسة تُرى , جودة تُلمس
                        </h1>
                    </motion.h1>


                    <div className='row'>
                        <div className='col-md-6 col-sm-12'>

                            <motion.div
                                ref={card1Ref}
                                initial={{ opacity: 0, x: -30 }}
                                animate={card1InView ? { opacity: 1, x: 0 } : { opacity: 0, x: -30 }}
                                transition={{ duration: 0.4,delay: 0.4  }}
                            >
                                <p className='aboutP'>
                                    <h3>رؤيتنا</h3>
                                    أن نكون الرائدين في دمج الإبداع الهندسي مع الفن المعماري لتقديم مشاريع مبتكرة تلبي احتياجات العملاء وتتفوق على توقعاتهم
                                </p>
                            </motion.div>


                            <motion.div
                                ref={card2Ref}
                                initial={{ opacity: 0, x: -30 }}
                                animate={card2InView ? { opacity: 1, x: 0 } : { opacity: 0, x: -30 }}
                                transition={{ duration: 0.4, delay: 0.2  }}
                            >
                                <p className='aboutP'>
                                    <h3>رسالتنا</h3>
                                    نلتزم بتقديم حلول هندسية متكاملة تشمل التصميم المعماري، الداخلي، الإنشائي، والكهربائي، مع لمسة فنية تميز كل مشروع.
                                </p>
                            </motion.div>

                            <motion.div
                                ref={card3Ref}
                                initial={{ opacity: 0, x: -30 }}
                                animate={card3InView ? { opacity: 1, x: 0 } : { opacity: 0, x: -30 }}
                                transition={{ duration: 0.4, delay: 0.2  }}
                            >
                                <p className='aboutP'>
                                    <h3>أهدافنا</h3>
                                    - تحقيق الابتكار المستمر في التصميمات الهندسية <br />
                                    - تحقيق أعلى مستويات الجودة في كل مرحلة من مراحل التنفيذ <br />
                                    - بناء علاقات شراكة طويلة الأمد مع عملائنا <br />
                                    - تعزيز التواصل مع العملاء عبر منصات متعددة
                                </p>
                            </motion.div>

                        </div>

                        <div className='col-md-6 col-sm-12 aboutImg'>
                            <img src={about} alt="aboutImg" className='img' />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Home;
